interface IMappingConnectorGradientProps {
  id: string;
  className: string;
  rightToLeft?: boolean;
}

/**
 * Define a gradient def for faded connectors.
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function MappingConnectorGradient({ className, id, rightToLeft }: IMappingConnectorGradientProps) {
  return (
    <linearGradient id={id} gradientUnits="userSpaceOnUse">
      {rightToLeft ? (
        <>
          <stop offset="30%" className={className} stopOpacity="0" />
          <stop offset="70%" className={className} />
        </>
      ) : (
        <>
          <stop offset="30%" className={className} />
          <stop offset="70%" className={className} stopOpacity="0" />
        </>
      )}
    </linearGradient>
  );
}
